<template>
  <a v-if="link && link != ''" :href="link" target="_blank" >
    <img :src="content" :alt="altTag" />
  </a>
  <a v-else-if="post && post != ''" v-on:click="WidgetUtils.post(post)">
    <img :src="content" :alt="altTag" />
  </a>
  <a v-else-if="download && download != ''" :href="WidgetUtils.renderLinkWithArgs(download)">
    <img :src="content" :alt="altTag" />
  </a>
  <a v-else-if="modal && modal != ''" v-on:click="WidgetUtils.modal(modal)">
    <img :src="content" :alt="altTag" />
  </a>
  <img v-else :src="content" :alt="altTag" />
</template>
<script>
import WidgetUtils from '../utils/WidgetUtils'
export default {
  props: ['content', 'link', 'post', 'download', 'modal', 'alt'],
  data () {
    return {
      WidgetUtils: WidgetUtils,
      altTag: this.alt === '' || this.alt === undefined || this.alt === null ? 'Decorative Image' : this.alt
    }
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/widgets/ImageWidget.vue